import Route from 'cio/routes/base';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { Entities, MetricTypes } from 'cio/utils/metrics/common';
import { unixNowMilliseconds } from 'cio/utils/time';

export default class DashboardRoute extends Route {
  @service analytics;
  @service('metrics') metricsService;
  @service store;

  crumb() {
    return {
      name: 'Dashboard',
      path: 'dashboard',
    };
  }

  model() {
    return this.modelFor('environment');
  }

  afterModel() {
    return this.store.findRecord('setup-guide', 'current').then((setupGuide) => {
      if (!setupGuide.completedAt) {
        this.router.transitionTo('setup-guide');
      }
    });
  }

  setupController(controller) {
    super.setupController(...arguments);

    controller.set('transitionMetaData', null);
    controller.set('renderedAtTimestamp', unixNowMilliseconds());
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      this.metricsService.clearMetrics(MetricTypes.Metric, Entities.ENVIRONMENT, controller.model.id);
      this.metricsService.clearMetrics(MetricTypes.TrackedLinkMetric, Entities.ENVIRONMENT, controller.model.id);

      controller.resetQueryParams();
    }
  }

  @action
  willTransition(transition) {
    let data = this.controller.transitionMetaData ?? {};
    data.route = transition?.to;

    let time = 0;

    if (this.controller.renderedAtTimestamp) {
      let timeSpentOnDashboardInMilliseconds = unixNowMilliseconds() - this.controller.renderedAtTimestamp;
      let timeSpentOnDashboardInSeconds = timeSpentOnDashboardInMilliseconds / 1000;

      let timeSpentRoundedToOneDecimal = Math.round(timeSpentOnDashboardInSeconds * 10) / 10;
      time = timeSpentRoundedToOneDecimal;
    }

    data.time = time;

    this.analytics.track('dashboard', 'navigate_away', data);
  }
}
